import * as yup from 'yup'
import { InferType } from 'yup'

import {
	DESCRIPTION_MAX_LENGTH,
	NAME_MAX_LENGTH,
	TITLE_MAX_LENGTH,
} from '@/constants'
import { TTranslationFunction } from '@/types'
import { maxLengthSchema } from '@/utils/fieldSchemas'

import { urlSchema } from '../fieldSchemas'

export const getAppInfoFormSchema = (t: TTranslationFunction) =>
	yup
		.object({
			name: maxLengthSchema(TITLE_MAX_LENGTH, t).required(
				t('ui__field_validation_errors__generic__required'),
			),
			developer: maxLengthSchema(TITLE_MAX_LENGTH, t).notRequired(),
			description: maxLengthSchema(DESCRIPTION_MAX_LENGTH, t).notRequired(),
			buttons: yup
				.array(
					yup.object({
						title: maxLengthSchema(NAME_MAX_LENGTH, t).required(
							t('ui__field_validation_errors__generic__required'),
						),
						url: urlSchema(t, { required: true }),
					}),
				)
				.required(),
			platforms: yup
				.array(
					yup.object({
						name: yup.string().required(),
						url: urlSchema(t, { required: false }),
					}),
				)
				.notRequired(),
		})
		.required()

export type TAppInfoFields = InferType<ReturnType<typeof getAppInfoFormSchema>>

export type TAppButton = TAppInfoFields['buttons'][number]
